// Initialize function that accepts section ID for uniqueness
function initFragranceCarousel(sectionId) {
  const carousel = document.getElementById(`fragrance-carousel-wrapper-${sectionId}`);
  const prevBtn = document.getElementById(`fragrance-prev-btn-${sectionId}`);
  const nextBtn = document.getElementById(`fragrance-next-btn-${sectionId}`);
  const indicatorsContainer = document.getElementById(`fragrance-indicators-${sectionId}`);
  const carouselContainer = document.getElementById(`fragrance-carousel-container-${sectionId}`);
  const sectionElement = document.getElementById(`fragrance-carousel-${sectionId}`);
  
  if (!carousel || !prevBtn || !nextBtn || !indicatorsContainer || !carouselContainer || !sectionElement) {
    console.error('Fragrance carousel elements not found');
    return;
  }
  
  const cards = carousel.querySelectorAll('.fragrance-product-card');
  const totalCards = cards.length;
  const uniqueCards = totalCards / 2; // Since we have duplicates
  
  let currentIndex = 0;
  let cardsPerView = getCardsPerView();
  let autoSlideInterval;
  let isTransitioning = false;
  let autoScrollSpeed = 6000; // Default speed
  let isAutoplayEnabled = sectionElement.dataset.autoplayEnabled === 'true';
  
  // Get auto scroll speed from section settings
  if (sectionElement.dataset.autoScrollSpeed) {
    autoScrollSpeed = parseInt(sectionElement.dataset.autoScrollSpeed) * 1000;
  }
  
  // Check if we should open cart after page load
  const urlParams = new URLSearchParams(window.location.search);
  const shouldOpenCart = urlParams.get('open_cart') === 'true';
  
  // Initialize
  function init() {
    createIndicators();
    updateCarousel();
    if (isAutoplayEnabled) {
      startAutoSlide();
    }
    setupCarouselHoverEvents();
    setupVariantTabs();
    setupCardClickHandlers();
    
    // Open cart if URL parameter is set
    if (shouldOpenCart) {
      setTimeout(() => {
        openCartDrawer();
        // Clean up URL parameter
        const newUrl = window.location.pathname + window.location.search.replace(/[?&]open_cart=true/, '').replace(/^&/, '?');
        window.history.replaceState({}, '', newUrl);
      }, 1000);
    }
  }
  
  // Create indicators
  function createIndicators() {
    indicatorsContainer.innerHTML = '';
    for (let i = 0; i < uniqueCards; i++) {
      const indicator = document.createElement('div');
      indicator.classList.add('fragrance-indicator');
      if (i === 0) indicator.classList.add('active');
      indicator.addEventListener('click', () => {
        stopAutoSlide();
        goToSlide(i);
        if (isAutoplayEnabled) {
          setTimeout(startAutoSlide, autoScrollSpeed);
        }
      });
      indicatorsContainer.appendChild(indicator);
    }
  }
  
  function getCardsPerView() {
    if (window.innerWidth > 1200) return 3;
    if (window.innerWidth > 768) return 2.5;
    return 1;
  }
  
  function updateCarousel() {
    if (isTransitioning) return;
    
    const cardWidth = window.innerWidth > 768 ? 
      cards[0].offsetWidth + 30 : 
      window.innerWidth;
    
    carousel.style.transform = `translateX(-${currentIndex * cardWidth}px)`;
    
    // Update indicators
    const indicators = indicatorsContainer.querySelectorAll('.fragrance-indicator');
    indicators.forEach((indicator, index) => {
      indicator.classList.toggle('active', index === currentIndex % uniqueCards);
    });
  }
  
  function goToSlide(index) {
    if (isTransitioning) return;
    currentIndex = index;
    updateCarousel();
  }
  
  function nextSlide() {
    if (isTransitioning) return;
    
    currentIndex++;
    updateCarousel();
    
    // Check if we need to loop back to the beginning
    if (currentIndex >= uniqueCards) {
      setTimeout(() => {
        isTransitioning = true;
        carousel.style.transition = 'none';
        currentIndex = 0;
        carousel.style.transform = `translateX(0)`;
        
        setTimeout(() => {
          carousel.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
          isTransitioning = false;
        }, 50);
      }, 500);
    }
  }
  
  function prevSlide() {
    if (isTransitioning) return;
    
    if (currentIndex <= 0) {
      // Jump to the duplicated set for smooth reverse transition
      isTransitioning = true;
      carousel.style.transition = 'none';
      currentIndex = uniqueCards;
      carousel.style.transform = `translateX(-${currentIndex * (window.innerWidth > 768 ? cards[0].offsetWidth + 30 : window.innerWidth)}px)`;
      
      setTimeout(() => {
        carousel.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
        isTransitioning = false;
        currentIndex--;
        updateCarousel();
      }, 50);
    } else {
      currentIndex--;
      updateCarousel();
    }
  }
  
  // Auto-slide functionality
  function startAutoSlide() {
    if (!isAutoplayEnabled) return;
    stopAutoSlide(); // Clear any existing interval
    autoSlideInterval = setInterval(nextSlide, autoScrollSpeed);
  }
  
  function stopAutoSlide() {
    clearInterval(autoSlideInterval);
  }
  
  // Setup carousel container hover events
  function setupCarouselHoverEvents() {
    // Stop auto-scroll when cursor enters the carousel container
    carouselContainer.addEventListener('mouseenter', stopAutoSlide);
    
    // Resume auto-scroll when cursor leaves the carousel container
    carouselContainer.addEventListener('mouseleave', () => {
      if (isAutoplayEnabled) {
        startAutoSlide();
      }
    });
  }
  
  // Setup variant tabs - FIXED VERSION
  function setupVariantTabs() {
    // Only attach event listeners to the first set of variant tabs (not duplicates)
    const variantTabContainers = Array.from(carousel.querySelectorAll('.fragrance-variant-tab-container')).slice(0, uniqueCards);
    
    variantTabContainers.forEach(container => {
      const tabs = container.querySelectorAll('.fragrance-variant-tab');
      
      tabs.forEach(tab => {
        tab.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const variantId = this.dataset.variantId;
          const variantPrice = this.dataset.variantPrice;
          const variantComparePrice = this.dataset.variantComparePrice;
          const variantTitle = this.dataset.variantTitle;
          const variantImage = this.dataset.variantImage;
          const sectionId = this.dataset.sectionId;
          const blockId = this.dataset.blockId;
          const cardId = this.dataset.cardId;
          
          // Find the tab container and update active state
          const tabContainer = this.closest('.fragrance-variant-tab-container');
          const allTabs = tabContainer.querySelectorAll('.fragrance-variant-tab');
          
          // Remove active class from all tabs in this container
          allTabs.forEach(t => t.classList.remove('active'));
          
          // Add active class to clicked tab
          this.classList.add('active');
          
          // Find the price display area and add to cart button in this card
          const card = this.closest('.fragrance-product-card');
          const priceDisplay = card.querySelector('.fragrance-price-display');
          const addToCartBtn = card.querySelector('.fragrance-add-to-cart');
          const buttonPriceContainer = card.querySelector('.fragrance-button-price');
          const productImage = card.querySelector('.fragrance-product-image');
          
          // Update price display (Compare Price First)
          if (priceDisplay) {
            if (variantComparePrice) {
              priceDisplay.innerHTML = `
                <span class="fragrance-compare-price">${variantComparePrice}</span>
                <span class="fragrance-current-price fragrance-sale-price">${variantPrice}</span>
              `;
            } else {
              priceDisplay.innerHTML = `
                <span class="fragrance-current-price">${variantPrice}</span>
              `;
            }
          }
          
          // Update price inside button
          if (buttonPriceContainer) {
            buttonPriceContainer.innerHTML = `<span class="fragrance-add-to-cart-price">${variantPrice}</span>`;
          }
          
          // Update button data attributes
          if (addToCartBtn) {
            addToCartBtn.dataset.variantId = variantId;
            addToCartBtn.dataset.price = variantPrice;
            addToCartBtn.dataset.comparePrice = variantComparePrice || '';
            addToCartBtn.dataset.variantTitle = variantTitle;
          }
          
          // Update product image if variant has an image
          if (productImage && variantImage) {
            // Add fade effect for smooth transition
            productImage.style.opacity = '0.7';
            
            // Create a new image to preload
            const tempImage = new Image();
            tempImage.src = variantImage;
            
            tempImage.onload = function() {
              // Once loaded, update the actual image
              productImage.src = variantImage;
              productImage.style.opacity = '1';
            };
            
            // Fallback in case image doesn't load
            tempImage.onerror = function() {
              productImage.style.opacity = '1';
              console.warn('Failed to load variant image:', variantImage);
            };
          }
          
          // Add visual feedback
          this.style.transform = 'scale(0.95)';
          setTimeout(() => {
            this.style.transform = '';
          }, 150);
          
          // Update both original and duplicate cards
          updateDuplicateCard(cardId, variantId, variantPrice, variantComparePrice, variantTitle, variantImage);
        });
      });
    });
  }
  
  // Setup card click handlers
  function setupCardClickHandlers() {
    // Add click event to product cards
    cards.forEach(card => {
      card.addEventListener('click', function(e) {
        // Check if the click is on the add to cart button or variant tabs
        if (e.target.closest('.fragrance-add-to-cart') || 
            e.target.closest('.fragrance-variant-tab')) {
          // Don't navigate if clicking on these elements
          return;
        }
        
        // Find the product link
        const productLink = card.querySelector('.fragrance-product-link');
        if (productLink && productLink.href) {
          // Navigate to product page
          window.location.href = productLink.href;
        }
      });
      
      // Add hover effect to indicate card is clickable
      card.style.cursor = 'pointer';
    });
  }
  
  // Function to update duplicate card
  function updateDuplicateCard(originalCardId, variantId, variantPrice, variantComparePrice, variantTitle, variantImage) {
    const duplicateCard = document.getElementById(originalCardId + '-duplicate');
    if (duplicateCard) {
      const duplicateTab = duplicateCard.querySelector(`[data-variant-id="${variantId}"]`);
      const duplicatePriceDisplay = duplicateCard.querySelector('.fragrance-price-display');
      const duplicateAddToCart = duplicateCard.querySelector('.fragrance-add-to-cart');
      const duplicateButtonPriceContainer = duplicateCard.querySelector('.fragrance-button-price');
      const duplicateProductImage = duplicateCard.querySelector('.fragrance-product-image');
      
      if (duplicateTab) {
        const duplicateTabContainer = duplicateTab.closest('.fragrance-variant-tab-container');
        const duplicateAllTabs = duplicateTabContainer.querySelectorAll('.fragrance-variant-tab');
        
        duplicateAllTabs.forEach(t => t.classList.remove('active'));
        duplicateTab.classList.add('active');
      }
      
      // Update price display (Compare Price First)
      if (duplicatePriceDisplay) {
        if (variantComparePrice) {
          duplicatePriceDisplay.innerHTML = `
            <span class="fragrance-compare-price">${variantComparePrice}</span>
            <span class="fragrance-current-price fragrance-sale-price">${variantPrice}</span>
          `;
        } else {
          duplicatePriceDisplay.innerHTML = `
            <span class="fragrance-current-price">${variantPrice}</span>
          `;
        }
      }
      
      // Update price inside button
      if (duplicateButtonPriceContainer) {
        duplicateButtonPriceContainer.innerHTML = `<span class="fragrance-add-to-cart-price">${variantPrice}</span>`;
      }
      
      if (duplicateAddToCart) {
        duplicateAddToCart.dataset.variantId = variantId;
        duplicateAddToCart.dataset.price = variantPrice;
        duplicateAddToCart.dataset.comparePrice = variantComparePrice || '';
        duplicateAddToCart.dataset.variantTitle = variantTitle;
      }
      
      // Update product image in duplicate card if variant has an image
      if (duplicateProductImage && variantImage) {
        // Add fade effect for smooth transition
        duplicateProductImage.style.opacity = '0.7';
        
        // Create a new image to preload
        const tempImage = new Image();
        tempImage.src = variantImage;
        
        tempImage.onload = function() {
          // Once loaded, update the actual image
          duplicateProductImage.src = variantImage;
          duplicateProductImage.style.opacity = '1';
        };
        
        // Fallback in case image doesn't load
        tempImage.onerror = function() {
          duplicateProductImage.style.opacity = '1';
          console.warn('Failed to load variant image in duplicate:', variantImage);
        };
      }
    }
  }
  
  // Navigation button event listeners
  prevBtn.addEventListener('click', () => {
    stopAutoSlide();
    prevSlide();
    if (isAutoplayEnabled) {
      setTimeout(startAutoSlide, autoScrollSpeed);
    }
  });
  
  nextBtn.addEventListener('click', () => {
    stopAutoSlide();
    nextSlide();
    if (isAutoplayEnabled) {
      setTimeout(startAutoSlide, autoScrollSpeed);
    }
  });
  
  // Handle window resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      cardsPerView = getCardsPerView();
      updateCarousel();
    }, 250);
  });
  
  // Touch/swipe support for mobile
  let touchStartX = 0;
  let touchEndX = 0;
  
  carousel.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
    stopAutoSlide();
  });
  
  carousel.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
    if (isAutoplayEnabled) {
      setTimeout(startAutoSlide, autoScrollSpeed);
    }
  });
  
  function handleSwipe() {
    const swipeThreshold = 50;
    if (touchEndX < touchStartX - swipeThreshold) {
      nextSlide();
    }
    if (touchEndX > touchStartX + swipeThreshold) {
      prevSlide();
    }
  }
  
  // Add to cart functionality with Shopify integration
  // Only attach event listeners to the first set of buttons (not duplicates)
  const addToCartButtons = Array.from(carousel.querySelectorAll('.fragrance-add-to-cart')).slice(0, uniqueCards);
  
  // Add a global flag to track if an add to cart operation is in progress
  let isAddingToCart = false;
  
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Prevent multiple clicks while processing
      if (this.dataset.processing === 'true' || isAddingToCart) {
        return;
      }
      
      // Set processing flag
      this.dataset.processing = 'true';
      isAddingToCart = true;
      
      const productId = this.dataset.productId;
      const variantId = this.dataset.variantId;
      const productHandle = this.dataset.productHandle;
      const sectionId = this.dataset.sectionId;
      const blockId = this.dataset.blockId;
      const cardId = this.dataset.cardId;
      const variantTitle = this.dataset.variantTitle;
      const price = this.dataset.price;
      const productName = this.parentElement.querySelector('.fragrance-product-name').textContent;
      const card = this.closest('.fragrance-product-card');
      const buttonText = this.querySelector('.fragrance-add-to-cart-text');
      const buttonPriceContainer = this.querySelector('.fragrance-button-price');
      const originalButtonText = buttonText.textContent;
      const originalButtonPrice = buttonPriceContainer.innerHTML;
      
      // Check if this is a view product button
      const isViewProduct = this.dataset.viewProduct === 'true';
      const isDiscoverySet = card.dataset.isDiscoverySet === 'true';
      const isDiscoveryPack = card.dataset.isDiscoveryPack === 'true';
      
      // If this is a view product button, don't proceed with add to cart
      if (isViewProduct || isDiscoveryPack) {
        // Clear processing flag
        this.dataset.processing = 'false';
        isAddingToCart = false;
        return;
      }
      
      // Create ripple effect
      const ripple = document.createElement('span');
      ripple.style.position = 'absolute';
      ripple.style.width = '20px';
      ripple.style.height = '20px';
      ripple.style.background = 'rgba(255, 255, 255, 0.5)';
      ripple.style.borderRadius = '50%';
      ripple.style.transform = 'translate(-50%, -50%)';
      ripple.style.pointerEvents = 'none';
      ripple.style.animation = 'fragrance-rippleEffect 0.6s ease-out';
      
      const rect = this.getBoundingClientRect();
      ripple.style.left = (e.clientX - rect.left) + 'px';
      ripple.style.top = (e.clientY - rect.top) + 'px';
      
      this.style.position = 'relative';
      this.appendChild(ripple);
      
      // Add to cart via Shopify AJAX
      if (productId && variantId) {
        addToCartShopify(variantId, 1, this);
      } else {
        // Fallback for non-product items
        buttonText.textContent = '✓ ADDED';
        buttonPriceContainer.style.display = 'none';
        this.style.background = 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)';
        
        // Add bounce animation to card
        card.style.animation = 'fragrance-bounce 0.5s ease';
        
        setTimeout(() => {
          buttonText.textContent = originalButtonText;
          buttonPriceContainer.style.display = '';
          buttonPriceContainer.innerHTML = originalButtonPrice;
          this.style.background = '';
          ripple.remove();
          card.style.animation = '';
          // Clear processing flag
          this.dataset.processing = 'false';
          isAddingToCart = false;
          // Refresh the page with cart parameter
          refreshPageAndOpenCart();
        }, 2000);
      }
      
      console.log(`Added ${productName} (${variantTitle}) to cart for ${price}`);
    });
  });
  
  // Shopify AJAX Add to Cart function
  function addToCartShopify(variantId, quantity, button) {
    const buttonText = button.querySelector('.fragrance-add-to-cart-text');
    const buttonPriceContainer = button.querySelector('.fragrance-button-price');
    const originalButtonText = buttonText.textContent;
    const originalButtonPrice = buttonPriceContainer.innerHTML;
    const card = button.closest('.fragrance-product-card');
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      // Success
      buttonText.textContent = '✓ ADDED';
      buttonPriceContainer.style.display = 'none';
      button.style.background = 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)';
      
      // Add bounce animation to card
      card.style.animation = 'fragrance-bounce 0.5s ease';
      
      // Show success notification
      showNotification('Product added to cart successfully!');
      
      // Update cart count
      updateCartCount();
      
      setTimeout(() => {
        buttonText.textContent = originalButtonText;
        buttonPriceContainer.style.display = '';
        buttonPriceContainer.innerHTML = originalButtonPrice;
        button.style.background = '';
        card.style.animation = '';
        // Clear processing flag
        button.dataset.processing = 'false';
        isAddingToCart = false;
        // Refresh the page with cart parameter
        refreshPageAndOpenCart();
      }, 1500);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      buttonText.textContent = 'ERROR';
      showNotification('Error adding product to cart. Please try again.', 'error');
      setTimeout(() => {
        buttonText.textContent = originalButtonText;
        // Clear processing flag
        button.dataset.processing = 'false';
        isAddingToCart = false;
      }, 2000);
    });
  }
  
  // Function to refresh page and open cart
  function refreshPageAndOpenCart() {
    // Add open_cart parameter to URL
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('open_cart', 'true');
    window.location.href = currentUrl.toString();
  }
  
  // Function to open cart drawer
  function openCartDrawer() {
    // Try multiple methods to open the cart drawer
    
    // Method 1: Try to trigger cart drawer open via theme object
    if (window.theme && window.theme.cartDrawer && typeof window.theme.cartDrawer.open === 'function') {
      window.theme.cartDrawer.open();
      return;
    }
    
    // Method 2: Try to find and click cart drawer trigger button
    const cartTriggers = [
      '.cart-drawer-trigger',
      '.js-drawer-open-right',
      '.js-drawer-open',
      '[data-drawer-toggle]',
      '.site-header__cart',
      '.cart-icon',
      '#cart-icon-bubble',
      '.cart-count-bubble'
    ];
    
    for (const selector of cartTriggers) {
      const trigger = document.querySelector(selector);
      if (trigger) {
        trigger.click();
        return;
      }
    }
    
    // Method 3: Try to find cart drawer and open it directly
    const cartDrawers = [
      '#cart-drawer',
      '.cart-drawer',
      '.drawer--right',
      '.ajaxcart',
      '.mini-cart',
      '[data-cart-drawer]'
    ];
    
    for (const selector of cartDrawers) {
      const drawer = document.querySelector(selector);
      if (drawer) {
        // Try to add active/open class
        drawer.classList.add('active', 'open', 'is-open', 'drawer--open');
        
        // Try to find close button and ensure it works
        const closeBtn = drawer.querySelector('.drawer__close, .js-drawer-close, [data-drawer-toggle]');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            drawer.classList.remove('active', 'open', 'is-open', 'drawer--open');
          });
        }
        return;
      }
    }
    
    // Method 4: Try Shopify theme sections API
    if (window.Shopify && window.Shopify.theme && window.Shopify.theme.sections && window.Shopify.theme.sections.instances) {
      const cartDrawerInstances = window.Shopify.theme.sections.instances.filter(instance => {
        return instance.type === 'cart-drawer' || instance.type === 'cart' || instance.type === 'header';
      });
      
      if (cartDrawerInstances.length > 0) {
        cartDrawerInstances.forEach(instance => {
          if (instance.cart && typeof instance.cart.open === 'function') {
            instance.cart.open();
          } else if (instance.open && typeof instance.open === 'function') {
            instance.open();
          }
        });
        return;
      }
    }
    
    // Method 5: If on cart page, no need to open drawer
    if (window.location.pathname === '/cart') {
      return;
    }
    
    // Method 6: As a last resort, redirect to cart page
    console.log('Could not open cart drawer, redirecting to cart page');
    window.location.href = '/cart';
  }
  
  // Update cart count function
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update cart count elements if they exist
        const cartCountElements = document.querySelectorAll('.cart-count, .cart-item-count, .cart-count-bubble, .site-header__cart-count');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
        });
        
        // Trigger cart updated event
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: cart
          }
        }));
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }
  
  // Function to show notification
  function showNotification(message, type = 'success') {
    // Create notification element
    const notification = document.createElement('div');
    notification.className = `fragrance-notification fragrance-notification-${type}`;
    notification.textContent = message;
    
    // Add to page
    document.body.appendChild(notification);
    
    // Show notification
    setTimeout(() => {
      notification.classList.add('show');
    }, 10);
    
    // Hide and remove after 3 seconds
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => {
        if (document.body.contains(notification)) {
          document.body.removeChild(notification);
        }
      }, 300);
    }, 3000);
  }
  
  // Add bounce animation and price display styles
  const style = document.createElement('style');
  style.textContent = `
    @keyframes fragrance-bounce {
      0%, 100% { transform: translateY(0) scale(1); }
      25% { transform: translateY(-5px) scale(1.02); }
      50% { transform: translateY(0) scale(1); }
      75% { transform: translateY(-2px) scale(1.01); }
    }
    
    @keyframes fragrance-rippleEffect {
      to {
        width: 200px;
        height: 200px;
        opacity: 0;
      }
    }
    
    .fragrance-price-display {
      display: flex;
      align-items: center;
      // justify-content: center;
      gap: 8px;
      margin: 5px 0;
      min-height: 24px;
    }
    
    .fragrance-current-price {
      font-weight: 600;
      font-size: 1.1em;
      color: var(--fragrance-text-color);
    }
    
    .fragrance-sale-price {
      // color: #ff4d4f;
      color: #E63946;
    }
    
    .fragrance-compare-price {
      color: #55555;
      text-decoration: line-through;
      font-size: 0.9em;
      order: -1; /* Ensures compare price is visually first */
    }
    
    .fragrance-add-to-cart {
      display: flex;
      flex-direction: row; /* Changed to row */
      align-items: center;
      justify-content: space-between; /* Pushes text and price to opposite ends */
      width: 100%;
      padding: 12px 20px;
      background: linear-gradient(135deg, var(--fragrance-primary-color), var(--fragrance-secondary-color));
      color: white;
      border: none;
      border-radius: 25px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      text-transform: uppercase;
      letter-spacing: 1px;
      font-size: 0.8em;
      position: relative;
      overflow: hidden;
    }
    
    .fragrance-add-to-cart:hover {
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(0,0,0,0.2);
    }
    
    .fragrance-button-price {
      display: flex;
      align-items: center;
      font-size: 0.9em;
      font-weight: 700;
    }
    
    .fragrance-add-to-cart-text {
      font-weight: 600;
      white-space: nowrap;
    }
    
    /* New styles for product image transitions */
    .fragrance-product-image {
      transition: opacity 0.3s ease;
    }
  `;
  document.head.appendChild(style);
  
  // Initialize the carousel
  init();
}